export const initialState = {
  title: 'Logout',
  nmUniqueId: 'no_user'
}

export default (state = initialState) => state
